export default __webpack_public_path__ + "static/media/rent a car.bc81f483.svg";